<template>
  <span class="whitespace-pre-wrap break-words"><slot></slot></span>
</template>
